
export default {
  data() {
    return {
      footerClass: '',
    };
  },
};
